// Портал — бага ангийн хуваарь (өөрийн цагтай): долоо хоног (нэгтгэсэн нүдтэй хүснэгт) эсвэл өдрөөр (цагийн жагсаалт).
// elementaryGrid.js нь админы elementary_timetable/grid.js-ийн хуулбар.
import React, { useMemo } from "react";
import moment from "moment";
import { DayTabs } from "./WeekView";
import { DAYS, DAY_MN, KIND_STYLE, buildGrid } from "./elementaryGrid";

const isNow = (s) => {
  const now = moment();
  const t = now.format("HH:mm");
  return now.isoWeekday() === s.day && s.startTime <= t && t < s.endTime;
};

export function ElementaryWeek({ slots }) {
  const rows = useMemo(() => buildGrid(slots), [slots]);
  const today = moment().isoWeekday();
  const Cell = ({ s, rowSpan, colSpan }) => (
    <td rowSpan={rowSpan} colSpan={colSpan} className="p-1 align-top">
      <div className={`h-full rounded-lg border px-2 py-1.5 text-[13px] leading-snug ${KIND_STYLE[s.kind] || ""}${isNow(s) ? " ring-2 ring-violet-400" : ""}`}>
        <div className="font-medium">{s.title}</div>
        {rowSpan > 1 && <div className="text-[11px] opacity-60">{s.startTime}–{s.endTime}</div>}
      </div>
    </td>
  );
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white">
      <table className="w-full min-w-[760px] border-collapse">
        <thead>
          <tr className="bg-gray-50 text-sm">
            <th className="w-[100px] p-2 text-left font-semibold text-gray-500">Хугацаа</th>
            {DAY_MN.map((d, i) => <th key={d} className={`p-2 text-left font-semibold${i + 1 === today ? " text-violet-700" : ""}`}>{d}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.startTime}-${r.endTime}`} className="border-t border-gray-100">
              <td className="p-2 text-xs text-gray-500 whitespace-nowrap align-top tabular-nums">{r.startTime} – {r.endTime}</td>
              {r.full ? <Cell s={r.full[0]} colSpan={5} />
                : DAYS.map((d) => {
                  const c = r.cells[d];
                  if (c?.covered) return null;
                  if (c?.slots) return <Cell key={d} s={c.slots[0]} rowSpan={c.rowSpan} />;
                  return <td key={d} />;
                })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ElementaryDay({ slots, day, onDay }) {
  const list = slots.filter((s) => s.day === day).sort((a, b) => a.startTime.localeCompare(b.startTime) || a.endTime.localeCompare(b.endTime));
  return (
    <div className="flex flex-col gap-3">
      <DayTabs day={day} onDay={onDay} />
      <div className="flex flex-col gap-1.5">
        {list.map((s) => (
          <div key={s.id} className={`flex items-start gap-3 rounded-xl border px-3 py-2 ${KIND_STYLE[s.kind] || ""}${isNow(s) ? " ring-2 ring-violet-400" : ""}`}>
            <div className="w-[88px] shrink-0 text-xs tabular-nums opacity-70 pt-0.5">{s.startTime} – {s.endTime}</div>
            <div className="flex-1 min-w-0 font-medium text-sm">{s.title}</div>
            {isNow(s) && <span className="now-badge">Одоо</span>}
          </div>
        ))}
        {!list.length && <div className="py-8 text-center text-sm" style={{ color: "var(--tj-violet-500)" }}>Энэ өдөр хуваарь алга</div>}
      </div>
    </div>
  );
}
